import React, { FC } from 'react'

import { IconSecurityCameraProps } from './IconSecurityCamera.types'
import * as Styled from './styles/IconSecurityCamera.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSecurityCamera: FC<IconSecurityCameraProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSecurityCameraProps['size'],
  isResponsive = false,
}: IconSecurityCameraProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m41 25.457-3.55 4.484a2.507 2.507 0 0 1-3.45.653l-.977-.707m5.875-5.86 2.098 1.43'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M7.086 28.965v12' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='m22.086 25.965-6 9h-9' stroke='#0D0D0D' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M28 30.45 11.902 20.046c-2.03-1.164-2.765-3.703-1.632-5.664l3.082-5.336c1.125-1.953 3.68-2.594 5.699-1.434L40.3 21.29l-7.102 8.418a4.207 4.207 0 0 1-5.199.742Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSecurityCamera
